import IconFile from "../icon/IconFile";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

export default function IconButtonFile(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconFile />
    </IconButtonContainer>
}